import React from "react";
import { Grid, Card, Box } from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import { useTranslate } from "src/locales";
import { getPainImage } from "./utils";

interface PartographBottomGridsProps {
    columns2: any[];
    rows2: any[];
    painLevelRecords: any[];
}

const PartographBottomGrids: React.FC<PartographBottomGridsProps> = ({
    columns2,
    rows2,
    painLevelRecords,
}) => {
    const { t } = useTranslate();

    return (
        <Card sx={{ marginBottom: "5px" }}>
            <Grid item sm={12} xs={12} md={12} xl={12} container>
                <Grid item sm={12} xs={12} md={6} xl={6} container>
                    <Grid
                        item
                        xs={12}
                        container
                        sx={{
                            m: 1,
                            width: "calc(100% - 16px)",
                            px: 2,
                            py: 1,
                            height: "48px",
                            borderBottom: "1px solid #E0E0E0",
                            backgroundColor: "#63B4FF33",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <span style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                            {t("partograf-form.amniotic-fluid")}
                        </span>
                    </Grid>
                    <Grid item sm={12} xs={12} md={12} xl={12} container sx={{ height: "240px" }}>
                        <ByzMuiDataGrid columns={columns2} pageSize={10} rows={rows2} sx={{ width: "100%", height: "100%" }} hideFooter />
                    </Grid>
                </Grid>

                <Grid item sm={12} xs={12} md={6} xl={6} container>
                    <Grid
                        item
                        xs={12}
                        sx={{
                            m: 1,
                            width: "calc(100% - 16px)",
                            px: 2,
                            py: 1,
                            height: "48px",
                            borderBottom: "1px solid #E0E0E0",
                            backgroundColor: "#63B4FF33",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <ByzMuiTypography variant="body1" sx={{ fontWeight: 700 }}>
                            {t("partograf-form.contraction-pain-level")}
                        </ByzMuiTypography>
                    </Grid>
                    <Grid item sm={12} xs={12} md={12} xl={12} container>
                        <Grid
                            item
                            sm={12}
                            xs={12}
                            md={12}
                            xl={12}
                            container
                            sx={{ overflowX: "auto", flexWrap: "nowrap", pb: 1 }}
                        >
                            {/* Sabit Etiketler Sütunu */}
                            <Box
                                sx={{
                                    position: "sticky",
                                    left: 0,
                                    bgcolor: "background.paper",
                                    zIndex: 2,
                                    borderRight: "2px solid #ddd",
                                    flexShrink: 0,
                                }}
                            >
                                {[5, 4, 3, 2, 1].map((level) => (
                                    <Box
                                        key={level}
                                        sx={{
                                            width: "40px",
                                            height: "48px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            borderBottom: "1px solid #0000001F",
                                        }}
                                    >
                                        <ByzMuiTypography variant="body2" sx={{ fontWeight: "bold" }}>
                                            {level}
                                        </ByzMuiTypography>
                                    </Box>
                                ))}
                            </Box>

                            {/* Dinamik Veri Sütunları */}
                            {painLevelRecords.map((record) => (
                                <Box key={record.id} sx={{ minWidth: "40px", flexShrink: 0 }}>
                                    {[5, 4, 3, 2, 1].map((level) => (
                                        <Box
                                            key={level}
                                            sx={{
                                                width: "40px",
                                                height: "48px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderBottom: "1px solid #0000001F",
                                                borderRight: "1px solid #0000000A",
                                            }}
                                        >
                                            {record.count >= level && (
                                                <img
                                                    src={getPainImage(record.value, record.name) || ""}
                                                    alt=""
                                                    style={{ width: "32px", height: "32px" }}
                                                />
                                            )}
                                        </Box>
                                    ))}
                                </Box>
                            ))}

                            {/* Eğer kayıt yoksa boşluk göster */}
                            {painLevelRecords.length === 0 && (
                                <Box sx={{ p: 2, color: "text.secondary" }}></Box>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Card>
    );
};

export default PartographBottomGrids;
